import { BreadcrumbGroup } from '@cloudscape-design/components';
import { getPPartId } from '@parallel-fluidics/shared/models/projects/parts';
import useGetProjectPartByDocId from 'features/pPart/hooks/useGetProjectPartByDocId';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetProjectByDocId } from '../../hooks/use-basicQueries';

export default function ProjectsBreadcrumbs({ pathnames, search }) {
  const navigate = useNavigate();
  const projectDocId = pathnames[1];
  const pPartDocId = pathnames[3];
  const { data: project } = useGetProjectByDocId(projectDocId);
  const { data: pPart } = useGetProjectPartByDocId({ projectDocId, pPartDocId });

  const breadcrumbItems = useMemo(() => {
    const items = [
      project?.isInternal
        ? { text: 'Internal Projects', href: `/projects${search}` }
        : { text: 'Customer Projects', href: `/projects${search}` },
    ];

    if (project?.name) {
      items.push({ text: project.name, href: `/projects/${projectDocId}${search}` });
    }

    if (pPart?.partId) {
      items.push({ text: getPPartId(pPart) });
    }

    return items;
  }, [project?.isInternal, project?.name, pPart, projectDocId, search]);

  return (
    <BreadcrumbGroup
      onClick={(e) => {
        e.preventDefault();
        const { href } = e.detail;
        if (href) {
          navigate(href);
        }
      }}
      items={breadcrumbItems}
    />
  );
}
ProjectsBreadcrumbs.propTypes = {
  pathnames: PropTypes.arrayOf(PropTypes.string).isRequired,
  search: PropTypes.string.isRequired,
};
